import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=1a4e3696&"
import script from "./ModuleView.vue?vue&type=script&lang=js&"
export * from "./ModuleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports